import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import About from '@/views/About'
import MobileHome from '@/views/MobileHome'
import Privacy from '@/views/Privacy'
import Service from '@/views/Service'

Vue.use(Router)
export default new Router({
  mode: 'history', // hash模式注释掉
  // base: './',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/mobile',
      name: 'mobile',
      component: MobileHome
    },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: Privacy
    },
    {
      path: '/service',
      name: 'service',
      component: Service
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js